/*
 * עברית היא מקור האמת של המפתחות.
 * מפתח חדש נוסף כאן קודם — ואז TypeScript דורש אותו בכל שאר השפות (שגיאת קומפילציה,
 * לא באג שמתגלה בזמן ריצה).
 */
export const he = {
    app_name: 'החזית האדומה',
    app_tagline: 'משחק אסטרטגיה בזמן אמת',

    menu_new_game: 'משחק חדש',
    menu_continue: 'המשך משחק',
    menu_settings: 'הגדרות',
    menu_continue_empty: 'אין משחק שמור',
    menu_coming_soon: 'בקרוב',

    lang_switch: 'החלף שפה',

    // התווית והמספר מופרדים בכוונה: רק המספר מקבל בידוד כיווני, ולא מכולה
    // שמכילה גם מילה בעברית. ראו .num ב-src/styles/global.css.
    build_version_label: 'גרסה',
    build_reload_hint: 'הקישו לרענון',

    update_title: 'גרסה חדשה זמינה',
    update_action: 'עדכן עכשיו',
    update_dismiss: 'אחר כך',
    offline_ready: 'המשחק מוכן — אפשר לשחק גם בלי חיבור לאינטרנט',

    theme_crimson: 'חזית אדומה',

    map_ridgeline: 'קו הרכס',
    map_duel: 'דו-קרב',
    map_twinbridges: 'שני הגשרים',
    map_bastions: 'המצודות',
    map_crossroads: 'צומת הדרכים',
    map_goldbasin: 'אגן הזהב',
    map_fourwinds: 'ארבע רוחות',
    map_pinwheel: 'טחנת הרוח',
    map_steppes: 'הערבות',

    difficulty_easy: 'קל',
    difficulty_normal: 'רגיל',
    difficulty_hard: 'קשה',
    menu_difficulty: 'רמת קושי',

    unit_gi: 'חי"ר',
    unit_harvester: 'קוצר',
    building_yard: 'מפקדה',
    building_refinery: 'מפעל עיבוד',
    building_power: 'תחנת כוח',
    building_barracks: 'קסרקטין',
    building_factory: 'מפעל רק"ם',
    building_pillbox: 'פילבוקס',
    building_turret: 'מגדל תותח',

    // תיאור בשורה אחת לכל פריט. השחקן לא אמור לנחש מה הוא בונה.
    building_yard_desc: 'לב הבסיס. בלעדיה אי אפשר לבנות כלום, ואם היא נופלת — הבנייה נעצרת.',
    building_refinery_desc: 'הקוצרים פורקים כאן עפרות והן הופכות לאשראי. זה כל מקור ההכנסה.',
    building_power_desc: 'מספקת חשמל. במחסור כל הייצור מאט וההגנות נחלשות.',
    building_barracks_desc: 'מייצר חי"ר. בלעדיו אין חיילים, וגם אין פילבוקס.',
    building_factory_desc: 'מייצר טנקים וקוצרים. פותח גם את מגדל התותח.',
    building_pillbox_desc: 'הגנה זולה. קטלנית לחי"ר, כמעט לא מזיקה לטנקים.',
    building_turret_desc: 'הגנה כבדה. עוצרת טנקים, מבזבזת פגזים על חי"ר.',
    unit_gi_desc: 'חייל זול. יעיל מול חי"ר, חלש מול שריון.',
    unit_grizzly_desc: 'טנק. חזק מול שריון ומול מבנים, איטי מול חי"ר מפוזר.',
    unit_harvester_desc: 'אוסף עפרות ומביא אותן למפעל העיבוד. אינו נלחם — שווה להגן עליו.',

    build_needs: 'דורש',
    build_power_use: 'צריכת חשמל',
    build_power_gain: 'ייצור חשמל',
    build_open: 'בנייה',
    build_tab_buildings: 'מבנים',
    build_tab_units: 'יחידות',
    build_place: 'הצב',
    build_cancel: 'בטל',
    build_rally: 'לאן יוצאות היחידות',
    build_hint_rally: 'הקישו על המפה — יחידות חדשות ייצאו לשם',
    build_hint_ready: 'המבנה מוכן — פתחו "בנייה" והקישו "הצב"',
    build_hint_place: 'הקישו על שטח מסומן כדי להציב',
    build_hint_bad_spot: 'אי אפשר לבנות שם — רק על השטח המסומן ליד הבסיס',
    unit_grizzly: 'טנק גריזלי',

    armor_flesh: 'בשר ודם',
    armor_light: 'שריון קל',
    armor_heavy: 'שריון כבד',
    armor_structure: 'מבנה',

    game_attack_move: 'תקוף-נוע',
    game_stop: 'עצור',

    result_victory: 'ניצחון',
    result_defeat: 'הפסד',
    result_back: 'לתפריט',

    game_select_all: 'בחר הכול',
    game_groups: 'קבוצה',
    game_close: 'סגור',
    build_idle: 'לא נבנה כלום כרגע',
    build_no_credits: 'אין מספיק אשראי — הבנייה עצרה',
    build_eta: 'עוד',
    build_power_hint: 'צריכה מתוך ייצור. מחסור מאט את כל הבנייה',
    build_explain_hint: 'מצב הסבר — הקש על פריט כדי לקרוא מה הוא עושה',
    game_repair: 'תקן',
    game_repair_on: 'מתקן',
    game_sell: 'מכור',
    game_sell_yes: 'למכור?',
    game_sell_confirm: 'מכירה מחזירה חצי מהעלות. להקיש שוב',
    armor_air: 'אוויר',
    unit_gunship: 'מסוק קרב',
    unit_gunship_desc: 'תוקף קרקע מגובה ומתעלם משטח. חסין לרוב הנשק — אבל נופל מהר מנ"מ.',
    building_airfield: 'מנחת',
    building_airfield_desc: 'מייצר מסוקים. פותח את הציר האווירי — ותור ייצור נוסף.',
    building_aa_gun: 'תותח נ"מ',
    building_aa_gun_desc: 'יורה למטוסים בלבד, וקטלני להם. חסר תועלת מוחלט מול קרקע.',
    game_box_select: 'סימון קבוצה — גררו כדי לבחור',
    brief_select: 'לחיצה ארוכה וגרירה מסמנת קבוצה',
    brief_goal: 'המטרה: להשמיד את בסיס האויב',
    brief_economy: 'הקוצר מביא עפרות ומייצר אשראי',
    brief_power: 'שמרו על עודף חשמל — מחסור מאט את הבנייה',
    result_time: 'זמן הקרב',
    result_built: 'יחידות שייצרתי',
    result_lost: 'יחידות שאיבדתי',
    result_again: 'שחק שוב',
    game_selected_one: 'נבחרה יחידה אחת',
    game_exit_confirm: 'המשחק נשמר. להקיש שוב כדי לצאת',
    game_exit_yes: 'לצאת?',
    game_unit_ready: 'מוכן',
    game_group_empty: 'לחיצה ארוכה משייכת את הבחירה לקבוצה',
    game_group_cleared: 'רוקנה קבוצה',
    game_group_hint: 'הקשה — שליפה · לחיצה ארוכה — שיוך הבחירה',
    game_under_attack: 'הבסיס תחת התקפה',
    // "נקה" ולא "בטל": ב"בטל" כבר משתמש תור הבנייה, והשניים נראים באותו מסך.
    game_deselect: 'נקה',
    game_selected: 'נבחרו',
    game_units: 'יחידות',
    game_pause: 'השהיה',
    game_resume: 'המשך',
    // קצר בכוונה. הנוסח הארוך נחתך בטלפון באמצע מילה.
    game_hint_select: 'הקישו לבחירה · הקשה כפולה לכל הסוג',

    game_back_to_menu: 'לתפריט',

    menu_multiplayer: 'משחק רשת',
    menu_multiplayer_note: 'שני שחקנים, קוד חדר',

    lobby_title: 'משחק רשת',
    lobby_tagline: 'שני שחקנים על אותה מפה',
    lobby_map: 'מפה',
    lobby_create: 'צור חדר',
    lobby_create_note: 'תקבלו קוד למסור ליריב',
    lobby_join: 'הצטרף',
    lobby_join_label: 'יש לכם קוד?',
    lobby_code_label: 'קוד החדר',
    lobby_waiting_hint: 'מסרו את הקוד ליריב — המשחק יתחיל כשיצטרף',
    lobby_connecting: 'מתחבר…',
    lobby_back: 'חזרה',
    lobby_retry: 'נסו שוב',
    lobby_error_no_server: 'שרת המשחק אינו מוגדר בבנייה הזו',
    lobby_error_network: 'אין חיבור לשרת המשחק',
    lobby_error_not_found: 'אין חדר עם הקוד הזה',
    lobby_error_full: 'החדר כבר מלא',
    lobby_error_bad_start: 'היריב משחק בגרסה אחרת',
    lobby_error_lost: 'החיבור נפל',

    net_player_label: 'שחקן',
    net_leave: 'עזיבת המשחק',
    net_status_waiting: 'ממתינים ליריב…',
    // "התפצלו" ולא "שגיאה": זה בדיוק מה שקרה, ואין ממנו דרך חזרה.
    net_status_desync: 'המשחקים התפצלו — אי אפשר להמשיך',
    net_status_peer_lost: 'היריב התנתק',
    net_status_ended: 'המשחק הסתיים',

    milestone_notice: 'קרב, כלכלה, בנייה ויריב מחשב. בחרו מפה ורמת קושי.',

    unit_bazooka: 'צוות נ"ט',
    // התיאור אומר גם מול מה **לא** — בלי זה השחקן מגלה את החיסרון רק אחרי שבזבז
    // גל שלם על מבנים.
    unit_bazooka_desc: 'רקטות נגד רכב. קורע טנקים וקוצרים; חסר תועלת מול חי"ר, מבנים ומטוסים.',
    unit_hound: 'כלב סיור',
    unit_hound_desc: 'רץ מהר ורואה רחוק — כך מגלים מה האויב בונה. אינו נלחם כלל ומת מכל ירייה.',
} as const;

export type TranslationKey = keyof typeof he;

/** מילון מלא של שפה אחת. חסר מפתח או מפתח עודף = שגיאת קומפילציה. */
export type Dictionary = Record<TranslationKey, string>;
